var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container page", attrs: { id: "chapter" } },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          {
            staticClass:
              "col-xs-12 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2",
          },
          [
            _vm.chapter.type === "trivia"
              ? _c(
                  "trivia",
                  [_c("back-button", { attrs: { backRoute: _vm.backRoute } })],
                  1
                )
              : _vm.chapter.type === "article"
              ? _c(
                  "article-chapter",
                  [_c("back-button", { attrs: { backRoute: _vm.backRoute } })],
                  1
                )
              : _vm.chapter.type === "video"
              ? _c(
                  "video-chapter",
                  [_c("back-button", { attrs: { backRoute: _vm.backRoute } })],
                  1
                )
              : _vm.chapter.type
              ? _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c("back-button", { attrs: { backRoute: _vm.backRoute } }),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12" }, [
                      _c("h1", [_vm._v(_vm._s(_vm.chapter.name))]),
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "col-xs-12 chapter-content",
                      domProps: { innerHTML: _vm._s(_vm.chapter.content) },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }